import React, { useMemo } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom'
import { Breadcrumbs, Typography, Box } from '@mui/material'
import { generateBreadcrumbs, isInspectorSubpage } from '../../utils/breadcrumbs'
import { useInspector } from '../../contexts/InspectorContext'

const InspectorBreadcrumbs: React.FC = () => {
  const location = useLocation()
  const { fp_code } = useParams()
  const { dynamicCrumbOverride } = useInspector()

  const breadcrumbs = useMemo(() => {
    return generateBreadcrumbs(location.pathname, dynamicCrumbOverride ?? undefined)
  }, [location.pathname, dynamicCrumbOverride])
  
  // Don't show breadcrumbs on dashboard
  if (!fp_code || !isInspectorSubpage(location.pathname)) {
    return null
  }
  
  return (
    <Box sx={{ mb: 1.5 }}>
      <Breadcrumbs
        separator="/"
        sx={{
          fontSize: '0.75rem',
          color: 'text.secondary',
          '& .MuiBreadcrumbs-ol': {
            flexWrap: 'nowrap',
          },
          '& .MuiBreadcrumbs-separator': {
            mx: 0.75,
            color: 'text.disabled',
          },
        }}
      >
        {breadcrumbs.map((crumb, index) => (
          crumb.isLink ? (
            <Link
              key={index}
              to={crumb.path}
              style={{
                textDecoration: 'none',
                color: 'inherit',
                whiteSpace: 'nowrap'
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  fontSize: '0.75rem',
                  color: 'text.secondary',
                  '&:hover': {
                    color: 'primary.main',
                    textDecoration: 'underline'
                  }
                }}
              >
                {crumb.label}
              </Typography>
            </Link>
          ) : (
            <Typography
              key={index}
              variant="caption"
              sx={{
                fontSize: '0.75rem',
                fontWeight: 500,
                color: 'text.secondary',
                whiteSpace: 'nowrap',
              }}
            >
              {crumb.label}
            </Typography>
          )
        ))}
      </Breadcrumbs>
    </Box>
  )
}

export default InspectorBreadcrumbs